<template>
    <div id="top">
		<div middle>
			<div logo @click="home"><img :src="getLogoPath()"></div>
			<div id="drive_list">
				<ul>
					<!-- <li data-id="-1" v-on:click="connectDrive"><img src="../asserts/image/load.png" /><p>{{$t("heaed.connect")}}</p></li> -->

          <!-- <li v-on:click="connectDrive" :class="curHIDDeviceObj !== null && curHIDDeviceObj.FirmwareVer == item.FirmwareVer ? 'connected':''" v-for="(item, index) in CRXList" :key="index" :ref="setRefIfFirst(index)">
              <img :src="getProductLogoPath(item.model)" />
              <p>{{item.name}}</p>
          </li> -->

          <li @click="switchProfile(item.value)" :class="item.value == curProfileName ? 'connected':''" v-for="(item, index) in profiles" :key="index" :ref="setRefIfFirst(index)">
            <!-- <img :src="getProductLogoPath(item.model)" /> -->
            <p>{{item.label}}</p>
        </li>
				</ul>
			</div>

			<div option>

        <!-- <el-dropdown @command="download" trigger="hover">
          <span class="el-dropdown-link" style=" font-weight: bold;font-size: small;color: #9c9c9c;margin-right: 20px;">
            <i class="el-icon-download  el-icon--right"></i> {{$t("heaed.download")}}
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="win" style="height: 40px; line-height: 40px;" command="Windows">{{$t("heaed.windows")}}</el-dropdown-item>
            <el-dropdown-item class="mac" style="height: 40px; line-height: 40px;" command="Mac">{{$t("heaed.mac")}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->


        <el-dropdown @command="selectLanguage">
          <span class="el-dropdown-link" style=" font-weight: bold;font-size: small;color: #9c9c9c;">
            <i class="el-icon-location-outline el-icon--right"></i> {{selectedLanguage}}
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :class="item.value"  style="height: 40px; line-height: 40px;" :command="item.value + '|' + item.label" v-for="(item, index) in languages">{{item.label}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

			</div>
		</div>
	</div>

</template>

<script>
import axios from 'axios';
import cmd10 from '../../../../theme/cmd1.0.config.json';
import { ToolsHandle } from '../../../../utils/tools.js';
// 导入HIDDIVICE 硬件通讯模块
import { HIDDeviceObj } from '../../../../asserts/js/hid_device.js';

export default {
  name: 'drive',
  data() {

    return {
      ThemeConf:null,
      CRXList:[],
      curHIDDeviceObj:null,
      selectedLanguage: '中文',
      DeviceModel:"",
      curProfileName:"配置一",
      profiles:[
        { label: this.$i18n.t("heaed.profile1"), value: 0},
        { label: this.$i18n.t("heaed.profile2"), value: 1},
        { label: this.$i18n.t("heaed.profile3"), value: 2},
        { label: this.$i18n.t("heaed.profile4"), value: 3},
      ],
      languages: [
        { label: '中文', value: 'zh'},
        { label: 'English', value: 'en'},
        { label: '日本語', value: 'jp' },
        { label: 'Россия', value: 'ru' },

        // { label: 'Español', value: 'es' },
        // { label: 'Français', value: 'fr' },
        // { label: 'Deutsch', value: 'de' },
        // { label: 'Italia', value: 'it' },
        // { label: 'العرب', value: 'ar' },
        // { label: 'Nederland', value: 'ne' },
        // { label: '한국', value: 'ko' },
        // { label: 'Portugal', value: 'po' },
        // { label: 'ประเทศไทย', value: 'th' },
        // { label: 'Việt Nam', value: 'vi' },
        // { label: 'polinesia', value: 'po' },
        
        // 添加更多语言
      ]
    }
  },
  mounted()
  {
      let context = this;
      let setLanguageText = function(languageCode)
      {
          for(let i in context.languages)
          {
             if(context.languages[i].value == languageCode)
             {
                context.selectedLanguage = context.languages[i].label;
                break;
             }
          }
      }

      let languageCode =  localStorage.getItem('language') || 'zh';
          setLanguageText(languageCode);
  },
  updated: function () 
  {

  },
  methods:
  {
      home()
      {
        window.location.reload();
      },
      //获取主题LOGO
      getLogoPath()
      {
        let imgUrl = require("../../../" + process.env.VUE_APP_THEMENAME + "/asserts/image/logo.png");   
        return imgUrl;
      },
      //更新连接设备状态
      updateList()
      {
          this.CRXList = this.ThemeConf.DeviceList;
          let moveItemInArray = function(array, fromIndex, toIndex) 
          {
                const element = array.splice(fromIndex, 1)[0];
                array.splice(toIndex, 0, element);
          }
          for(let i=0;i<this.CRXList.length;i++)
          {
            if(this.CRXList[i].FirmwareVer == this.curHIDDeviceObj.FirmwareVer)
            {
                moveItemInArray(this.CRXList,i,0);

                this.DeviceModel = this.CRXList[i].model;
                this.profiles = this.profiles.slice(0, this.CRXList[i].Profiles);

                this.curProfileName = this.curHIDDeviceObj.ProfileIndex;
            }
          }
          
          //模拟点击第一个点击的驱动
          if(this.activeIndex>-1)
          {
              this.$refs.firstItemRef[this.activeIndex].click();
          }


          this.languages = this.ThemeConf.languages;
      },
      //点击连接HID设备
      async connectDrive()
      {
        await navigator.hid.requestDevice({filters:this.ThemeConf.verifyDevices})
        .then(async devices => 
        {
              console.log(devices);

              // 连接到设备
              const device = devices[0];
              await device.open();
        
              if(device.opened)
              {
                window.location.reload();
              }
              // 监听连接事件
              // device.addEventListener('data', event => {
              //   console.log('设备已连接', event);
              // });
        
              // // 监听断开事件
              // device.addEventListener('disconnect', event => {
              //   console.log('设备已断开', event);
              // });
              
        }).catch(error => 
        {
            console.error('连接错误', error);
        });
        
      },
      //获取设备图标
      getProductLogoPath(model)
      {
        let imgUrl = require("../../../drives/" + model + "/asserts/image/logo.png");   
        return imgUrl;
      },
      setRefIfFirst(index) 
      {
        return index === 0 ? 'firstItemRef' : null;
      },
      //点击打开驱动模块
      async callParentMethod(FirmwareVer) 
      {
          this.$emit('child-event',FirmwareVer);
      },
      download(item)
      {
          this.$message({message:'暂未开放.....敬请期待!',type: 'warning',center: true,offset:100,duration:1000});
      },
      selectLanguage(item)
      {
          let items = item.split("|");
          this.selectedLanguage = items[1];
          this.$i18n.locale = items[0];

          localStorage.setItem('language', this.$i18n.locale);
          window.location.reload();
      },
      async switchProfile(val)
      {
          this.$confirm(this.$i18n.t("msg.confirmInfoProfile"), this.$i18n.t("msg.confirmTitProfile"), 
          {
            confirmButtonText: this.$i18n.t("msg.confirmOKProfile"),
            cancelButtonText: this.$i18n.t("msg.confirmNoProfile"),
            type: 'warning'
          }).then(() => 
          {

            cmd10.SET_DEVICE_PROFILE_CMD[5] = parseInt(val);

            const outputReportData = new Uint8Array(cmd10.SET_DEVICE_PROFILE_CMD.map(hex => parseInt(hex, 16)));
            this.curHIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

            setTimeout(()=>{window.location.reload()},10);
            
          }).catch(() => {});

      }
  }
}

</script>